// Gravação de voz no navegador e conversão de arquivo em base64, usadas pelas páginas de Áudio e de Imagem (ditar o prompt).
import { useEffect, useRef, useState } from 'react';

export const two = (n: number) => String(Math.floor(n)).padStart(2, '0');

/** Base64 do arquivo sem o prefixo `data:…;base64,` (FileReader evita estourar a pilha com arquivos grandes). */
export const toBase64 = (f: Blob) => new Promise<string>((ok, no) => {
  const r = new FileReader();
  r.onload = () => { const s = String(r.result); ok(s.slice(s.indexOf(',') + 1)); };
  r.onerror = () => no(new Error('não foi possível ler o arquivo'));
  r.readAsDataURL(f);
});

/** Gravação no navegador (MediaRecorder): contador e parar. `onDone` recebe o arquivo e a duração medida (o webm gravado não traz duração). */
export function useRecorder(onDone: (f: File, seconds: number) => void) {
  const [recording, setRecording] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [error, setError] = useState<string | null>(null);
  const rec = useRef<MediaRecorder | null>(null);
  const stream = useRef<MediaStream | null>(null);
  const tick = useRef<ReturnType<typeof setInterval> | null>(null);
  const done = useRef(onDone);
  done.current = onDone;
  const supported = typeof MediaRecorder !== 'undefined' && !!navigator.mediaDevices?.getUserMedia;

  const release = () => {
    stream.current?.getTracks().forEach((t) => t.stop());
    stream.current = null;
    if (tick.current) clearInterval(tick.current);
    tick.current = null;
  };
  const start = async () => {
    setError(null);
    try {
      const s = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.current = s;
      const mime = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus'].find((t) => MediaRecorder.isTypeSupported(t));
      const mr = new MediaRecorder(s, mime ? { mimeType: mime } : undefined);
      const chunks: Blob[] = [];
      const t0 = Date.now();
      mr.ondataavailable = (e) => { if (e.data.size) chunks.push(e.data); };
      mr.onstop = () => {
        release(); setRecording(false);
        const type = mr.mimeType || mime || 'audio/webm';
        const ext = type.includes('mp4') ? 'm4a' : type.includes('ogg') ? 'ogg' : 'webm';
        const d = new Date();
        done.current(new File(chunks, `gravacao-${two(d.getHours())}${two(d.getMinutes())}${two(d.getSeconds())}.${ext}`, { type }), (Date.now() - t0) / 1000);
      };
      mr.start(1000);
      rec.current = mr;
      setSeconds(0); setRecording(true);
      tick.current = setInterval(() => setSeconds((Date.now() - t0) / 1000), 500);
    } catch {
      release();
      setError('não foi possível usar o microfone; confira a permissão do navegador');
    }
  };
  const stop = () => { if (rec.current?.state === 'recording') rec.current.stop(); };
  useEffect(() => () => {   // saiu da página gravando: descarta a gravação e solta o microfone
    if (rec.current) { rec.current.onstop = null; if (rec.current.state === 'recording') rec.current.stop(); }
    release();
  }, []);
  return { supported, recording, seconds, error, start, stop };
}
